import SignIn from "components/LogIn";
import NonAuthPage from "components/shared/NonAuthPage";

const LogIn = () => {
    return (
        <NonAuthPage userAuthenticated={false}>
            <SignIn />
        </NonAuthPage>
    );
};

export default LogIn;
